import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { useLingui } from '@lingui/react';
import { Grid, Group, Tabs } from '@mantine/core';
import { AccountTabItem } from './AccountTabItem';
export const AccountTabList: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    setOpenModal
  } = useModalAction();
  return <Group justify="center" mb={{
    sm: 20
  }}>
      <Tabs.List>
        <Grid gutter={{
        base: 10,
        sm: 20
      }}>
          <AccountTabItem iconName="icon-pr-line-user" itemName={i18n._('Account Info')} value="info" />
          <AccountTabItem iconName="icon-pr-line-shield" itemName={i18n._('Security')} value="security" />
          <AccountTabItem iconName="icon-pr-line-referral" itemName={i18n._('Preferences')} value="preferences" />
          <AccountTabItem iconName="icon-pr-line-checked-circle-broken" itemName={i18n._('Verifications')} value="verifications" handleClick={() => setOpenModal(MODAL.VERIFY_PROFILE)} />
        </Grid>
      </Tabs.List>
    </Group>;
};